import { toast } from 'sonner';

// Toast types and convenience functions
export const showToast = {
  success: (message, options) => {
    toast.success(message, {
      position: 'top-right',
      ...options
    });
  },

  error: (message, options) => {
    toast.error(message, {
      position: 'top-right',
      ...options
    });
  },

  warning: (message, options) => {
    toast.warning(message, {
      position: 'top-right',
      ...options
    });
  },

  info: (message, options) => {
    toast.info(message, {
      position: 'top-right',
      ...options
    });
  },

  // sonner's toast.loading returns string | number by design; the id is returned verbatim so callers
  // can reuse the same toast (e.g. withToast). Coercing it would break sonner's strict id matching.
  loading: (message, options) => { // NOSONAR
    return toast.loading(message, {
      position: 'top-right',
      ...options
    });
  }
};

// Error handler utility
export const handleApiError = (error, fallbackMessage = 'An error occurred') => {
  const message = error?.response?.data?.message || 
                  error?.message || 
                  fallbackMessage;
  
  console.error('API Error:', error);
  showToast.error(message, { position: 'top-right' });
  
  return message;
};

// Success handler utility
export const handleApiSuccess = (message, data) => {
  console.log('API Success:', data);
  showToast.success(message, { position: 'top-right' });
  return data;
};

// Promise wrapper with automatic toast handling
export const withToast = async (promise, {
  loading = 'Loading...',
  success = 'Operation completed successfully',
  error = 'Operation failed',
  showSuccess = true,
  toastOptions = {}
} = {}) => {
  const toastId = showToast.loading(loading, toastOptions);
  
  try {
    const result = await promise;
    
    if (showSuccess) {
      showToast.success(success, { id: toastId, ...toastOptions });
    } else {
      toast.dismiss(toastId);
    }
    
    return result;
  } catch (err) {
    const errorMessage = err?.response?.data?.message || err?.message || error;
    showToast.error(errorMessage, { id: toastId, ...toastOptions });
    throw err;
  }
};

// Export toast instance for advanced usage
export { toast } from 'sonner';

// Global error handler (optional)
export const setupGlobalErrorHandler = () => {
  globalThis.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    showToast.error('An unexpected error occurred.');
  });
  
  globalThis.addEventListener('error', (event) => {
    console.error('Global error:', event.error);
    showToast.error('An unexpected error occurred.');
  });
};
